import * as SaveSearchPanelStyles from './styles';

export interface ISaveSearchPanel {
  handleClick: () => void;
  className?: string;
  isSearchSaved: boolean;
}

function SaveSearchPanel({
  handleClick,
  className,
  isSearchSaved,
}: ISaveSearchPanel) {
  return (
    <SaveSearchPanelStyles.SWhitePanel className={className}>
      <SaveSearchPanelStyles.IconAndTextContainer>
        <SaveSearchPanelStyles.SStarOutline
          width="40"
          height="40"
          color="ORANGE"
        />
        <div>
          <SaveSearchPanelStyles.Header>
            Get notified when similar ads are posted
          </SaveSearchPanelStyles.Header>
          <SaveSearchPanelStyles.Subtitle>
            Save this search to get notifications for ads like this
          </SaveSearchPanelStyles.Subtitle>
        </div>
      </SaveSearchPanelStyles.IconAndTextContainer>
      <SaveSearchPanelStyles.SButton
        ofType="SECONDARY"
        onClick={handleClick}
        disabled={isSearchSaved}
      >
        Notify Me
      </SaveSearchPanelStyles.SButton>
    </SaveSearchPanelStyles.SWhitePanel>
  );
}

export { SaveSearchPanel };
